/**
 * Web-local mirror of bridge envelope helpers (CRA does not transpile @bilt/types).
 * Keep in sync with packages/types/src/nativeBridge.ts
 */

export const NATIVE_BRIDGE_VERSION = 1 as const;

export type BiltNativeRequest = { type: string; [key: string]: unknown };
export type BiltNativeEvent = { type: string; [key: string]: unknown };

export type BiltBridgeEnvelope = {
  source: 'bilt-native' | 'bilt-web';
  v: typeof NATIVE_BRIDGE_VERSION;
  id?: string;
  payload: BiltNativeRequest | BiltNativeEvent;
};

export function isBridgeEnvelope(value: unknown): value is BiltBridgeEnvelope {
  if (!value || typeof value !== 'object') return false;
  const o = value as Record<string, unknown>;
  return (
    (o.source === 'bilt-native' || o.source === 'bilt-web') &&
    o.v === NATIVE_BRIDGE_VERSION &&
    o.payload !== null &&
    typeof o.payload === 'object'
  );
}
